import React, { Component } from 'react'
import Helmet from 'react-helmet'

import { Link } from 'react-router-dom'

import Loading404 from '../../../components/images/loading-404.svg'

class StaticUnmatched extends Component {
  render() {
    return (
      <div className="template template--static template--static-unmatched">
        <Helmet>
          <title>404 | Podcast Campfire</title>
          <meta property="og:title" content="404 | Podcast Campfire"/>
        </Helmet>
        <div className="error error--404">
          <img src={Loading404} className="media media--loading-state"/>
          <h1 className="heading--no-foundation">404</h1>
          <p className="text--no-foundation">You're far from the campsite.</p>
          <p className="text--no-foundation">Head back <Link to={`/`} className="link">home</Link> and regroup.</p>
        </div>
      </div>
    );
  }
}

export default StaticUnmatched;



// WEBPACK FOOTER //
// ./src/app/pages/static/templates/static-unmatched.jsx